export default {
  storageTokenKeyName: 'accessToken',
  storageUserDataName: 'userData',
  storagePermissions: 'userPermissions',

  agentMessageKey: 'msgHistoryData',
  agentStatusKey: 'msgStatData',
}
